import { RevenueDashboardApiRepository } from "@/app/infrastructures/repositories/api/RevenueDashboardApiRepository";
import { injectable } from "tsyringe";
import { RevenueBreakdownApiRequest, RevenueBreakdownData } from '@/domain/entities/RevenueDashboard';
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";
import { CustomerLeaderboardResponse, PosRevenueOverview, RevenueDashboardCustomerListRequest, RevenueOverviewApiRequest } from '@/domain/entities/RevenueDashboard';

@injectable()
export class RevenueDashboardPresenter {
  private repository: RevenueDashboardApiRepository;

  constructor(repository: RevenueDashboardApiRepository) {
    this.repository = repository;
  }

  getRevenueOverview(params: RevenueOverviewApiRequest): Promise<PosRevenueOverview> {
    return this.repository.getRevenueOverview(params);
  }

  public async getCustomerLeaderboard(
    params: RevenueDashboardCustomerListRequest
  ): Promise<CustomerLeaderboardResponse> {
    return this.repository.getCustomerLeaderboard(params);
  }
  public async getProductTypes(search = ""): Promise<ResponsePayloadV2> {
    return this.repository.getProductTypes(search);
  }

  public async getRevenueBreakdown(
    params: RevenueBreakdownApiRequest
  ): Promise<RevenueBreakdownData> {
    return this.repository.getRevenueBreakdown(params);
  }

  public async getDestinationCities(
    search: string,
    page: number,
    limit: number
  ): Promise<ResponsePayloadV2> {
    return this.repository.getDestinationCities(search, page, limit);
  }

  public async getCommodities(
    search: string,
    page: number,
    limit: number
  ): Promise<ResponsePayloadV2> {
    return this.repository.getCommodities(search, page, limit);
  }
}
